export const footerLinks = {
    'pk-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://www.wingie.pk/ar/flights/to-riyadh/',
                    title: 'رياض',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/to-jeddah/',
                    title: 'جدة',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/to-dammam/',
                    title: 'الدمام',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/to-manila/',
                    title: 'مانيلا',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/to-chennai/',
                    title: 'تشيناي',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/to-delhi/',
                    title: 'دلهي',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://www.wingie.pk/ar/flights/az-azerbaijan/',
                    title: 'أذربيجان',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/bh-bahrain/',
                    title: 'البحرين',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/eg-egypt/',
                    title: 'مصر',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/in-india/',
                    title: 'الهند',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/jo-jordan/',
                    title: 'الأردن',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/ke-kenya/',
                    title: 'كينيا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://www.wingie.pk/ar/flights/airlines/saudi-arabian-airlines/',
                    title: 'السعودية',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/airlines/flynas/',
                    title: 'طيران ناس',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/airlines/qatar-airways/',
                    title: 'الخطوط الجوية القطرية\n',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/airlines/egyptair/',
                    title: 'مصر للطيران',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/airlines/etihad-airways/',
                    title: 'شَرِكَة ٱلْاِتِّحَاد لِلطَّيْرَان',
                },
                {
                    href: 'https://www.wingie.pk/ar/flights/airlines/royal-jordanian/',
                    title: 'الملكيَّة الأردنيَّة',
                },
            ],
        },
    ],
    'pk-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://www.wingie.pk/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://www.wingie.pk/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://www.wingie.pk/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/flights/to-cairo/',
                    title: 'Cairo',
                },
                {
                    href: 'https://www.wingie.pk/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://www.wingie.pk/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://www.wingie.pk/flights/sa-saudi-arabia/',
                    title: 'Saudi Arabia',
                },
                {
                    href: 'https://www.wingie.pk/flights/ae-united-arab-emirates/',
                    title: 'United Arab Emirates',
                },
                {
                    href: 'https://www.wingie.pk/flights/kw-kuwait/',
                    title: 'Kuwait',
                },
                {
                    href: 'https://www.wingie.pk/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://www.wingie.pk/flights/qa-qatar/',
                    title: 'Qatar',
                },
                {
                    href: 'https://www.wingie.pk/flights/om-oman/',
                    title: 'Oman',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://www.wingie.pk/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/flights/airlines/flyadeal/',
                    title: 'flyadeal',
                },
                {
                    href: 'https://www.wingie.pk/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/flights/airlines/nile-air/',
                    title: 'Nile Air',
                },
                {
                    href: 'https://www.wingie.pk/flights/airlines/emirates/',
                    title: 'Emirates',
                },
            ],
        },
    ],
    'pk-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://www.wingie.pk/es/vuelos/a-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/a-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/a-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/a-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/a-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/a-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://www.wingie.pk/es/vuelos/az-azerbaijan/',
                    title: 'Azerbaiyán',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/bh-bahrain/',
                    title: 'Bahréin',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/eg-egypt/',
                    title: 'Egipto',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/jo-jordan/',
                    title: 'Jordania',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://www.wingie.pk/es/vuelos/companias-aereas/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/companias-aereas/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/companias-aereas/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/companias-aereas/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/companias-aereas/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/es/vuelos/companias-aereas/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://www.wingie.pk/de/flug/nach-riyadh/',
                    title: 'Riad',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/nach-dschidda/',
                    title: 'Dschidda',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/nach-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/nach-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/nach-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/nach-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://www.wingie.pk/de/flug/az-aserbaidschan/',
                    title: 'Aserbaidschan',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/eg-aegypten/',
                    title: 'Ägypten',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/in-indien/',
                    title: 'Indien',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/jo-jordanien/',
                    title: 'Jordanien',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/ke-kenia/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://www.wingie.pk/de/flug/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/de/flug/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://www.wingie.pk/ru/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/to-jeddah/',
                    title: 'Джедда',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/to-delhi/',
                    title: 'Дели',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://www.wingie.pk/ru/flights/az-azerbaijan/',
                    title: 'Азербайджан',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/in-india/',
                    title: 'Индия',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://www.wingie.pk/ru/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/ru/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-it': [
        {
            title: 'Destinazioni Top',
            items: [
                {
                    href: 'https://www.wingie.pk/it/flights/to-riyadh/',
                    title: 'Riyad',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                {
                    href: 'https://www.wingie.pk/it/flights/az-azerbaijan/',
                    title: 'Azerbaigian',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/eg-egypt/',
                    title: 'Egitto',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/jo-jordan/',
                    title: 'Giordania',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/ke-kenya/',
                    title: 'Kenya',
                },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                {
                    href: 'https://www.wingie.pk/it/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/it/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-fr': [
        {
            title: 'Meilleures Destinations',
            items: [
                {
                    href: 'https://www.wingie.pk/fr/flights/to-riyadh/',
                    title: 'Riyad',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/to-jeddah/',
                    title: 'Djeddah',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/to-manila/',
                    title: 'Manille',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                {
                    href: 'https://www.wingie.pk/fr/flights/az-azerbaijan/',
                    title: 'Azerbaïdjan',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/bh-bahrain/',
                    title: 'Bahreïn',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/eg-egypt/',
                    title: 'Égypte',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/in-india/',
                    title: 'Inde',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/jo-jordan/',
                    title: 'Jordanie',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/ke-kenya/',
                    title: 'Kenya',
                },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                {
                    href: 'https://www.wingie.pk/fr/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/fr/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-pt': [
        {
            title: 'Principais Destinos',
            items: [
                {
                    href: 'https://www.wingie.pk/pt/flights/to-riyadh/',
                    title: 'Riad',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                {
                    href: 'https://www.wingie.pk/pt/flights/az-azerbaijan/',
                    title: 'Azerbaijão',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/eg-egypt/',
                    title: 'Egito',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/in-india/',
                    title: 'Índia',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/jo-jordan/',
                    title: 'Jordânia',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/ke-kenya/',
                    title: 'Quênia',
                },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                {
                    href: 'https://www.wingie.pk/pt/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/pt/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-ro': [
        {
            title: 'Destinații de Top',
            items: [
                {
                    href: 'https://www.wingie.pk/ro/flights/to-riyadh/',
                    title: 'Riad',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                {
                    href: 'https://www.wingie.pk/ro/flights/az-azerbaijan/',
                    title: 'Azerbaidjan',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/eg-egypt/',
                    title: 'Egipt',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/jo-jordan/',
                    title: 'Iordania',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/ke-kenya/',
                    title: 'Kenya',
                },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                {
                    href: 'https://www.wingie.pk/ro/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/ro/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-pl': [
        {
            title: 'Najlepsze Destynacje',
            items: [
                {
                    href: 'https://www.wingie.pk/pl/flights/to-riyadh/',
                    title: 'Rijad',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/to-jeddah/',
                    title: 'Dżudda',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                {
                    href: 'https://www.wingie.pk/pl/flights/az-azerbaijan/',
                    title: 'Azerbejdżan',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/bh-bahrain/',
                    title: 'Bahrajn',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/eg-egypt/',
                    title: 'Egipt',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/in-india/',
                    title: 'Indie',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/jo-jordan/',
                    title: 'Jordania',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                {
                    href: 'https://www.wingie.pk/pl/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/pl/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-lt': [
        {
            title: 'Populiariausi Miestai',
            items: [
                {
                    href: 'https://www.wingie.pk/lt/flights/to-riyadh/',
                    title: 'Rijadas',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/to-jeddah/',
                    title: 'Džida',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/to-dammam/',
                    title: 'Damamas',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/to-chennai/',
                    title: 'Čenajus',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/to-delhi/',
                    title: 'Delis',
                },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                {
                    href: 'https://www.wingie.pk/lt/flights/az-azerbaijan/',
                    title: 'Azerbaidžanas',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/bh-bahrain/',
                    title: 'Bahreinas',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/eg-egypt/',
                    title: 'Egiptas',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/in-india/',
                    title: 'Indija',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/jo-jordan/',
                    title: 'Jordanija',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/ke-kenya/',
                    title: 'Kenija',
                },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                {
                    href: 'https://www.wingie.pk/lt/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/lt/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-uz': [
        {
            title: 'Eng Mashhur Shaharlar',
            items: [
                {
                    href: 'https://www.wingie.pk/uz/flights/to-riyadh/',
                    title: 'Riyod',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/to-jeddah/',
                    title: 'Jidda',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/to-delhi/',
                    title: 'Dehli',
                },
            ],
        },
        {
            title: 'Mashhur Mamlakatlar',
            items: [
                {
                    href: 'https://www.wingie.pk/uz/flights/az-azerbaijan/',
                    title: 'Ozarbayjon',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/bh-bahrain/',
                    title: 'Bahrayn',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/eg-egypt/',
                    title: 'Misr',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/in-india/',
                    title: 'Hindiston',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/jo-jordan/',
                    title: 'Iordaniya',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/ke-kenya/',
                    title: 'Keniya',
                },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                {
                    href: 'https://www.wingie.pk/uz/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/uz/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-sr': [
        {
            title: 'Најчешће Дестинације',
            items: [
                {
                    href: 'https://www.wingie.pk/sr/flights/to-riyadh/',
                    title: 'Ријад',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/to-jeddah/',
                    title: 'Џеда',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/to-dammam/',
                    title: 'Дамам',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/to-chennai/',
                    title: 'Ченај',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/to-delhi/',
                    title: 'Делхи',
                },
            ],
        },
        {
            title: 'Популарне Земље',
            items: [
                {
                    href: 'https://www.wingie.pk/sr/flights/az-azerbaijan/',
                    title: 'Азербејџан',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/bh-bahrain/',
                    title: 'Бахреин',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/eg-egypt/',
                    title: 'Египат',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/in-india/',
                    title: 'Индија',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/jo-jordan/',
                    title: 'Јордан',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/ke-kenya/',
                    title: 'Кенија',
                },
            ],
        },
        {
            title: 'Популарне Авиокомпаније',
            items: [
                {
                    href: 'https://www.wingie.pk/sr/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/sr/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-ky': [
        {
            title: 'Эң популярдуу шаарлар',
            items: [
                {
                    href: 'https://www.wingie.pk/ky/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/to-jeddah/',
                    title: 'Жидда',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/to-delhi/',
                    title: 'Дели',
                },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                {
                    href: 'https://www.wingie.pk/ky/flights/az-azerbaijan/',
                    title: 'Азербайжан',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/in-india/',
                    title: 'Индия',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                {
                    href: 'https://www.wingie.pk/ky/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/ky/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-tg': [
        {
            title: 'Беҳтарин шаҳрҳо',
            items: [
                {
                    href: 'https://www.wingie.pk/tg/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/to-jeddah/',
                    title: 'Жидда',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/to-delhi/',
                    title: 'Делҳи',
                },
            ],
        },
        {
            title: 'Кишварҳои маъмул',
            items: [
                {
                    href: 'https://www.wingie.pk/tg/flights/az-azerbaijan/',
                    title: 'Озарбойжон',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/bh-bahrain/',
                    title: 'Баҳрайн',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/eg-egypt/',
                    title: 'Миср',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/in-india/',
                    title: 'Ҳиндустон',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/jo-jordan/',
                    title: 'Урдун',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Ширкатҳои ҳавопаймоии маъмул',
            items: [
                {
                    href: 'https://www.wingie.pk/tg/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/tg/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-kk': [
        {
            title: 'Ең танымал қалалар',
            items: [
                {
                    href: 'https://www.wingie.pk/kk/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/to-jeddah/',
                    title: 'Жидда',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/to-delhi/',
                    title: 'Дели',
                },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                {
                    href: 'https://www.wingie.pk/kk/flights/az-azerbaijan/',
                    title: 'Әзербайжан',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/in-india/',
                    title: 'Үндістан',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                {
                    href: 'https://www.wingie.pk/kk/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/kk/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-nl': [
        {
            title: 'Top Bestemmingen',
            items: [
                {
                    href: 'https://www.wingie.pk/nl/flights/to-riyadh/',
                    title: 'Riyad',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/to-manila/',
                    title: 'Manilla',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                {
                    href: 'https://www.wingie.pk/nl/flights/az-azerbaijan/',
                    title: 'Azerbeidzjan',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/bh-bahrain/',
                    title: 'Bahrein',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/eg-egypt/',
                    title: 'Egypte',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/jo-jordan/',
                    title: 'Jordanië',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                {
                    href: 'https://www.wingie.pk/nl/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.pk/nl/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'pk-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://www.wingie.pk/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://www.wingie.pk/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://www.wingie.pk/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://www.wingie.pk/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://www.wingie.pk/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://www.wingie.pk/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://www.wingie.pk/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.pk/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://www.wingie.pk/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://www.wingie.pk/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://www.wingie.pk/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://www.wingie.pk/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.pk/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://www.wingie.pk/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://www.wingie.pk/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://www.wingie.pk/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.pk/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://www.wingie.pk/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'pk-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://www.wingie.pk/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://www.wingie.pk/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://www.wingie.pk/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://www.wingie.pk/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://www.wingie.pk/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://www.wingie.pk/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://www.wingie.pk/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.pk/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://www.wingie.pk/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://www.wingie.pk/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://www.wingie.pk/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://www.wingie.pk/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://www.wingie.pk/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://www.wingie.pk/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://www.wingie.pk/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://www.wingie.pk/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.pk/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://www.wingie.pk/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'pk-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://www.wingie.pk/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://www.wingie.pk/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://www.wingie.pk/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://www.wingie.pk/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://www.wingie.pk/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://www.wingie.pk/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://www.wingie.pk/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://www.wingie.pk/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://www.wingie.pk/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://www.wingie.pk/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://www.wingie.pk/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://www.wingie.pk/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://www.wingie.pk/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://www.wingie.pk/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://www.wingie.pk/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://www.wingie.pk/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.pk/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://www.wingie.pk/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'pk-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://www.wingie.pk/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://www.wingie.pk/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://www.wingie.pk/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://www.wingie.pk/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://www.wingie.pk/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://www.wingie.pk/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://www.wingie.pk/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://www.wingie.pk/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://www.wingie.pk/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.pk/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://www.wingie.pk/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://www.wingie.pk/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.pk/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.pk/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.pk/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.pk/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.pk/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.pk/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'pk-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.pk/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://www.wingie.pk/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://www.wingie.pk/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://www.wingie.pk/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://www.wingie.pk/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://www.wingie.pk/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://www.wingie.pk/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://www.wingie.pk/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.pk/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.pk/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://www.wingie.pk/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://www.wingie.pk/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.pk/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.pk/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.pk/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.pk/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.pk/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.pk/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'pk-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://www.wingie.pk/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://www.wingie.pk/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://www.wingie.pk/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://www.wingie.pk/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://www.wingie.pk/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://www.wingie.pk/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://www.wingie.pk/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://www.wingie.pk/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://www.wingie.pk/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.pk/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.pk/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://www.wingie.pk/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.pk/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.pk/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.pk/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.pk/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.pk/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.pk/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'pk-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://www.wingie.pk/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://www.wingie.pk/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://www.wingie.pk/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://www.wingie.pk/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://www.wingie.pk/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://www.wingie.pk/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://www.wingie.pk/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://www.wingie.pk/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://www.wingie.pk/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.pk/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://www.wingie.pk/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://www.wingie.pk/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.pk/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.pk/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.pk/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.pk/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.pk/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.pk/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'pk-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://www.wingie.pk/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://www.wingie.pk/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://www.wingie.pk/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://www.wingie.pk/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://www.wingie.pk/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://www.wingie.pk/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://www.wingie.pk/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://www.wingie.pk/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://www.wingie.pk/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.pk/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://www.wingie.pk/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://www.wingie.pk/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.pk/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.pk/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.pk/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.pk/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.pk/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.pk/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}